import { html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { connect } from 'pwa-helpers';
import { capitalizeText } from '../../../common/utils/util';
import store from '../../../store/store';
import { StoreState } from '../../../store/store.interface';
import { Select } from '../../selector/selector';
import { fetchDepartments } from '../../user-profile/thunks/fetch-departments.thunk';
import { getDepartmentsByCountry } from '../../user-profile/user-profile.selectors';

/**
 * Select component to allow user to select a department option.
 * Department options are loaded based on the countryCode property and cached in Redux.
 */
@customElement('mhecomm-department-selector')
export class DepartmentSelect extends connect(store)(Select) {
  @property()
  type = '';

  @property()
  countryCode = '';

  @state()
  protected options: any[] = [];

  constructor() {
    super();
    this.defaultOptionFormValue = '';
    this.defaultOptionDisplayValue = 'Choose a Department';
    this.loadingDisplayValue = 'loading department';
  }

  stateChanged(state: StoreState) {
    if (this.countryCode) {
      this.options = getDepartmentsByCountry(this.countryCode)(state);
    }
  }

  protected async updated(_changedProperties: Map<string | number | symbol, unknown>) {
    super.updated(_changedProperties);
    if (_changedProperties.has('countryCode') && this.countryCode) {
      store.dispatch(fetchDepartments({ countryCode: this.countryCode }));
    }
  }

  protected onSelectOption() {
    this.dispatchEvent(
      new CustomEvent('onDepartmentSelection', {
        detail: this.selectedOption,
      })
    );
  }

  protected showOptionsTemplate() {
    return html`<option value="${this.defaultOptionFormValue}">${this.defaultOptionDisplayValue}</option> ${this.options
        ? html`${this.options.map(
            ({ name, id }) => html` <option value="${id}" ?selected=${id === this.selectedOption}
              >${this.capitalize ? capitalizeText(name) : name}</option
            >`
          )}`
        : nothing}`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-department-selector': DepartmentSelect;
  }
}
